import React from "react"
import { localize } from "locale"
import withModal from "hoc/withModal"
import { P } from "styledComponents/Typography"

const NotAvailableModal = () => <P>{localize("uploadNotAvailableInPreview")}</P>

export default withModal(() => localize("notAvailable"))(NotAvailableModal)
